module.exports = __webpack_public_path__ + "static/media/square-up-left.c42bb4eb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/square-up-left.svg
// module id = 3560
// module chunks = 7